import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartCtx = createContext(null);
const KEY = "bfx_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          quantity: qty,
          name: product.name,
          slug: product.slug,
          image: product.thumbnail,
          price: product.price,
        },
      ];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((id, qty) => {
    if (qty <= 0) return setItems((p) => p.filter((i) => i.product_id !== id));
    setItems((p) => p.map((i) => (i.product_id === id ? { ...i, quantity: qty } : i)));
  }, []);

  const remove = useCallback((id) => {
    setItems((p) => p.filter((i) => i.product_id !== id));
  }, []);

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, count, subtotal, open, setOpen, add, updateQty, remove, clear }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
